var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpOutline24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9583 19C11.4232 19 10.9895 18.5662 10.9895 18.0312L10.9895 8.30722L9.09957 10.1965C8.72116 10.5748 8.10774 10.5747 7.72945 10.1962C7.35116 9.81784 7.35126 9.20441 7.72968 8.82613L11.2733 5.28365C11.6485 4.90856 12.2557 4.90503 12.6352 5.27573L16.2623 8.8182C16.6451 9.19206 16.6523 9.80544 16.2785 10.1882C15.9046 10.571 15.2912 10.5783 14.9084 10.2044L12.9271 8.26928L12.9271 18.0312C12.9271 18.5662 12.4933 19 11.9583 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpOutline24);
export default __webpack_public_path__ + "static/media/arrow-up-outline-24.6c3bf7789bac0726ad3c8a66d3b9ad1f.svg";
export { ForwardRef as ReactComponent };